import '../../assets/arrow.css';
import { jsx as t } from "react/jsx-runtime";
import * as a from "@radix-ui/react-tooltip";
import m from "clsx";
const e = "_arrow_1xx3p_3", p = {
  arrow: e
}, c = (r) => {
  const { className: o, ...s } = r;
  return /* @__PURE__ */ t(a.Arrow, { className: m(p.arrow, o), ...s });
};
c.displayName = "Tooltip.Content.Arrow";
export {
  c as Arrow
};
